import { updateLinksAttributes } from '../utils/handleAttributes';

export default function mainSeoBlock() {
  const widgetName = 'mainSeoBlock';
  const widgetOpts = mainSeoBlockOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items, $widget);
      } else {
        $('.mainSeoBlock-container').remove();
      }
    },
  });
}

function createCustomSeo(widgetData, $widget) {
  const $seo = $widget.find('.card-widget-item');
  const { Title, Description, URL, ImageWithPath } = widgetData[0];

  $seo.replaceWith(`
      <div class="seo-wrapper">
        <div class="img-container">
        <div class="image-frame"></div>
          <img src="${ImageWithPath}" alt="${Title}">
        </div>
        <div class="seo-content">
          <h1 class="seo-title">${Title}</h1>
          <div class="seo-description">${Description}</div>
          ${
            URL == null
              ? ''
              : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>
        </div>
      </div>`
          }
    `);
}
